module.exports = __webpack_public_path__ + "static/media/tastecard.878412ad.png";